<template>
  <div>
    <print-temp />
  </div>
</template>

<script>
import printTemp from './../../assignmentManage/PrintTemp.vue'
import storage from '@/utils/storagehandle'

export default {
  name: 'putawayPrintTemp',
  components: {
    printTemp
  },
  destroyed () {
    storage.removeItem('taskPrintBillPutawayGoodList')
    storage.removeItem('taskPrintBillPutawayGoodsTotalPiece')
    storage.removeItem('taskPrintBillPutawayGoodsSku')
  }
}
</script>



// WEBPACK FOOTER //
// src/page/rollsHomework/putawayList/putawayPrintTemp.vue